import styled, { CSSProperties, useTheme } from 'styled-components';

interface VariantGroupProps {
    number: number;
    style?: CSSProperties;
    className?: string;
}

export const VariantGroup = (props: VariantGroupProps) => {
    const theme = useTheme();
    console.log('Theme', theme);

    return (
        <S_VariantGroup className={props.className} style={props.style}>
            {props.number}
            <S_Plus>+</S_Plus>
        </S_VariantGroup>
    );
};

const S_VariantGroup = styled.div`
    width: 30px;
    height: 30px;
    background-color: ${({ theme }) => theme.colors.black};
    font-family: ${({ theme }) => theme.fonts.semiBold};
    font-size: 13px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: ${({ theme }) => theme.colors.white};
    padding: 0 0 1px 1px;
`;

const S_Plus = styled.div`
    position: absolute;
    right: -7px;
    top: -7px;
    font-size: 15px;
    color: ${({ theme }) => theme.colors.black};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({ theme }) => theme.colors.black};
    line-height: 0;
    padding: 0 0 2px 1px;
`;
